import { log } from './log/';

// Convenience object with silent versions of reporter functions
export const silent = {
  log: (message: string, error?: Error): void => {
    log(message, error, { silent: true });
  },
};
